import $ from "jquery";

window.$ = $;
window.jQuery = $;

$(document).ready(function () {
  $("#main_menu > ul li").click(function () {
    $(this).find("#main_menu > ul li ul").slideToggle();
    var t = $(this).find("#main_menu > ul li ul");
    $("#main_menu > ul li ul").not(t).slideUp();
  });

  var max_h = 0;
  $("#main_menu > ul li ul").each(function () {
    var h = parseInt($(this).css("height"));
    if (max_h < h) {
      max_h = h;
    }
  });

  // 마우스 over 시
  let isMouseInsideMenu = false;
  let isMouseInsideSubmenu = false;
  let isMouseInsideSubSubMenu = false;

  $("#main_menu, #main_menu > ul > li, #main_menu > ul > li > ul").mouseenter(
    function () {
      // menu bg

      if ($(this).is("#main_menu")) {
        isMouseInsideMenu = true;
      } else if ($(this).is("#main_menu > ul > li")) {
        isMouseInsideSubmenu = true;
      } else if ($(this).is("#main_menu > ul > li > ul")) {
        isMouseInsideSubSubMenu = true;
      }

      if (
        isMouseInsideMenu == true ||
        isMouseInsideSubmenu == true ||
        isMouseInsideSubSubMenu == true
      ) {
        var menuHeight = $("#header").outerHeight();
        $(".menu_bg").css({
          top: menuHeight + "px",
          height: max_h + "px",
        });

        $("#header").addClass("open");
      }
    }
  );

  $("#main_menu, #main_menu > ul > li, #main_menu > ul > li > ul").mouseleave(
    function () {
      if (!$("#main_menu").has($(this)).length) {
        isMouseInsideMenu = false;
      } else if (!$("#main_menu > ul > li").has($(this)).length) {
        isMouseInsideSubmenu = false;
      } else if (!$("#main_menu > ul > li > ul").has($(this)).length) {
        isMouseInsideSubSubMenu = false;
      }
      if (
        isMouseInsideMenu == false &&
        isMouseInsideSubmenu == false &&
        isMouseInsideSubSubMenu == false
      ) {
        $(".menu_bg").css("height", "0");
        $("#header").removeClass("open");
      }
    }
  );

  $("#main_menu > ul > li").mouseenter(function () {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
  });
  $("#main_menu > ul > li").mouseleave(function () {
    $(this).removeClass("active");
  });
});
